module.exports = __webpack_public_path__ + "img/server-version.6d4944e3.svg";